<div class="sidenav-menu-outer" [perfectScrollbar]="psConfig" [disabled]="settings.fixedSidenavUserContent">
    <div fxLayout="column" fxLayoutAlign="center center" class="user-block mt-4 text-center" [class.py-3]="settings.menuType != 'mini'" [class.py-2]="settings.menuType == 'mini'">
        <!-- <img [src]="userImage" alt="user-image"> -->
        <ng-container *ngIf="isInstitute;else elseFaculty">
            <mat-icon style="transform:scale(2)">apartment</mat-icon>
        </ng-container>
        <ng-template #elseFaculty >
            <ng-container *ngIf ="isFaculty && profileImg; else elseHod">
                <!-- <mat-icon style="transform: scale(3);"> checked_circle</mat-icon>     -->
                <img width="175px" height="150px" src="{{profileImg}}" alt="">
            </ng-container>
        </ng-template>
        <ng-template #elseHod >
            <ng-container *ngIf ="isHod; else elseStudent">
                <!-- <mat-icon style="transform: scale(3);"> checked_circle</mat-icon>     -->
                <img width="175px" height="150px" src="{{profileImg}}" alt="">
            </ng-container>
        </ng-template>
        <ng-template #elseStudent >
            <ng-container *ngIf ="isStudent && profileImg; else elseBlock">
                <!-- <mat-icon style="transform: scale(3);"> checked_circle</mat-icon>     -->
                <img width="175px" height="150px" src="{{profileImg}}" alt="">
            </ng-container>
        </ng-template>
        <ng-template #elseBlock>
            <mat-icon style="transform: scale(3);"> account_box</mat-icon>
        </ng-template>
        <p *ngIf="settings.menuType != 'mini'" class="mt-2">
            <b *ngIf="isModerator">Moderator</b>
            <b>{{appId}}</b>
        </p>
        <p *ngIf="settings.menuType == 'default'" class="secondary-text-color">{{email}}</p>
    </div>
    <mat-divider></mat-divider>

    <div id="vertical-menu" [perfectScrollbar]="psConfig" [disabled]="!settings.fixedSidenavUserContent">
        <app-vertical-menu [menuItems]="menuItems" [menuParentId]="0"></app-vertical-menu>
    </div>
</div>